module.exports = __webpack_public_path__ + "static/media/mapBusRight.61835c67.png";